import React from "react";
import "./LifeAtPestel.css";

export default function LifeAtPestel({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    title: "LIFE AT PESTEL & PARTNERS",
    subtitle:
      "Discover what makes our workplace special through the eyes of our team members",
    testimonials: [
      {
        img: "/assets/images/Career/profile1.png",
        name: "Sarah Chen",
        role: "Senior Tax Consultant",
        quote:
          "The mentorship program here is exceptional. I've grown tremendously in my role, and the collaborative environment makes every day engaging and rewarding.",
      },
      {
        img: "/assets/images/Career/profile2.png",
        name: "Michael Rodriguez",
        role: "Audit Manager",
        quote:
          "The work-life balance and professional development opportunities have exceeded my expectations. This is truly a place where careers flourish.",
      },
    ],
    block: {
      image: "/assets/images/Career/life-office.png",
      title: "COLLABORATIVE EXCELLENCE",
      description:
        "Our open and collaborative work environment encourages innovation and knowledge sharing. From brainstorming sessions to client presentations, every team member's voice is valued and heard.",
      list: [
        "Modern office spaces designed for collaboration",
        "Regular team building and social events",
        "Cross-functional project opportunities",
      ],
    },
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    title: "LA VIE CHEZ PESTEL & PARTNERS",
    subtitle:
      "Découvrez ce qui rend notre environnement de travail unique à travers le regard de nos collaborateurs",
    testimonials: [
      {
        img: "/assets/images/Career/profile1.png",
        name: "Sarah Chen",
        role: "Consultante fiscale senior",
        quote:
          "Le programme de mentorat est exceptionnel. J’ai énormément progressé dans mon rôle et l’environnement collaboratif rend chaque journée enrichissante.",
      },
      {
        img: "/assets/images/Career/profile2.png",
        name: "Michael Rodriguez",
        role: "Responsable audit",
        quote:
          "L’équilibre entre vie professionnelle et personnelle ainsi que les opportunités de développement ont dépassé mes attentes.",
      },
    ],
    block: {
      image: "/assets/images/Career/life-office.png",
      title: "EXCELLENCE COLLABORATIVE",
      description:
        "Notre environnement de travail ouvert et collaboratif favorise l’innovation et le partage des connaissances. Des sessions de réflexion aux présentations clients, chaque voix est écoutée et valorisée.",
      list: [
        "Espaces de travail modernes conçus pour la collaboration",
        "Événements réguliers de team building et activités sociales",
        "Opportunités de projets transversaux",
      ],
    },
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { title, subtitle, testimonials, block } = data;

  return (
    <div className="life-wrapper container">
      {/* Heading */}
      <h2 className="life-title">{title}</h2>
      <p className="life-subtitle">{subtitle}</p>

      <div className="row mt-4">
        {/* LEFT SIDE — Testimonials */}
        <div className="col-lg-6">
          {testimonials.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <div className="d-flex align-items-center gap-3">
                <img
                  src={item.img}
                  alt="profile"
                  className="testimonial-img"
                />
                <div>
                  <h5 className="testimonial-name">{item.name}</h5>
                  <p className="testimonial-role">{item.role}</p>
                </div>
              </div>

              <p className="testimonial-quote">"{item.quote}"</p>
            </div>
          ))}
        </div>

        {/* RIGHT SIDE — Image + Content */}
        <div className="col-lg-6 mt-4 mt-lg-0 mobile-box">
          <div>
            <img
              src={block.image}
              alt="office"
              className="life-image"
            />
          </div>

          <div>
            <h4 className="life-block-title mt-3">{block.title}</h4>

            <p className="life-block-desc">{block.description}</p>

            <ul className="life-list">
              {block.list.map((item, idx) => (
                <li key={idx}>
                  <img
                    src="/assets/images/Career/greentick.png"
                    alt=""
                    width={15}
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
